<div class="map-wrap" [attr.id]="this.mapId">
  <div class="controls_top">
    <label class="check_img btn_search" title="{{'Search on the map'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <label class="check_img btn_measuring" title="{{'Distance measurement'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <label class="check_img btn_areameasuring" title="{{'Area measurement'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <label class="check_img btn_titles" title="{{'Show objects name'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <label class="check_img btn_geozonetitles" title="{{'Show geozones name'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <label *ngIf="isMode('tracking')" class="check_img btn_watchobj" title="{{'Watch for selected'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <label *ngIf="isMode('history')" class="check_img btn_showtrack" title="{{'Show all tracks'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <label *ngIf="isMode('tracking')" class="check_img btn_showtail" title="{{'Show objects tail'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <div class="controls-btn">
      <button class="btn_img btn_whiteblue btn_plus"></button>
      <button class="btn_img btn_whiteblue btn_minus"></button>
    </div>
  </div>
  <div class="controls_search" id="controls_search" style="display:none">
    <label class="check_img btn_direction" title="{{'Build a route'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <label class="check_img btn_reversegeocode" title="{{'Point information'|translate }}">
      <input type="checkbox">
      <span></span>
    </label>
    <input type="text" placeholder="{{'Search on the map'|translate }}" class="inp_geocode">
    <button class="btn_geocode">{{'Search'|translate }}</button>
  </div>
  <div class="controls_bottom" *ngIf="isMode('history')">
    <button class="btn_img btn_whiteblue btn_tostart" title="{{'To first point'|translate }}"></button>
    <button class="btn_img btn_whiteblue btn_prev" title="{{'To previous point'|translate }}"></button>
    <button class="btn_img btn_whiteblue btn_pause" id="playbackbutton" title="{{'Play/pause'|translate }}"></button>
    <button class="btn_img btn_whiteblue btn_next" title="{{'To next point'|translate }}"></button>
    <button class="btn_img btn_whiteblue btn_toend" title="{{'To last point'|translate }}"></button>
    <div class="date">
      <span id="playbacktime"></span>
      <input id="playbackscroll" type="range" min="0" max="100" value="0" />
    </div>
    <div class="dropdown dropup dropclick" id="playbackspeed">
      <input type="text" readonly="readonly" value="x10" />
      <ul>
        <li>x5</li>
        <li>x10</li>
        <li>x25</li>
        <li>x50</li>
        <li>x100</li>
      </ul>
    </div>
    <span></span>
    <div class="checkboxes">
      <label class="check_img check_parking2" title="{{'Show parkings'|translate }}">
        <input type="checkbox">
        <span></span>
      </label>
      <label class="check_img check_key" title="{{'Show ignition events'|translate }}">
        <input type="checkbox">
        <span></span>
      </label>
      <label class="check_img check_gas" title="{{'Show fuel events'|translate }}">
        <input type="checkbox">
        <span></span>
      </label>
      <label class="check_img check_alert2" title="{{'Show alarms'|translate }}">
        <input type="checkbox">
        <span></span>
      </label>
      <label class="check_img check_rules" title="{{'Show norms events'|translate }}">
        <input type="checkbox">
        <span></span>
      </label>
      <label class="check_img check_gear" title="{{'Show equipment events'|translate }}">
        <input type="checkbox">
        <span></span>
      </label>
      <label class="check_img check_photo2" title="{{'Show photos'|translate }}">
        <input type="checkbox">
        <span></span>
      </label>
    </div>
  </div>
  <div class="map"> </div>

  <div id="mapObjectModal" style="display:none">
    <div class="modalhead">
      <div>
        <label>ObjectName</label>
      </div>
      <span><img src="/assets/icons/close_white.svg" id="close"></span>
    </div>
    <div class="modalbody">
      <div class="map_fixed_info">
        <div>
          <label>{{'Time'|translate }}:</label>
          <span></span>
        </div>
        <div>
          <label>{{'Address'|translate }}:</label>
          <span></span>
        </div>
      </div>
      <div class="data"></div>
    </div>
    <div class="modalfooter">
      <div class="status_icons">
      </div>
      <div></div>
      <div><button class="btn_img btn_graydark btn_report"></button></div>
      <button class="btn_img btn_graydark btn_point" title="{{ 'Show on the map'| translate }}"></button>
      <button class="btn_img btn_graydark btn_photo" title="{{'Show photos'|translate }}"></button>
      <button class="btn_img btn_graydark btn_code" title="{{ 'Send command to device'| translate }}"></button>
    </div>
  </div>



  <div id="generatorObjectModal" style="display:none">
    <div class="modalhead">
      <div>
        <label>ObjectName</label>
      </div>
      <span><img src="/assets/icons/close_white.svg" id="close"></span>
    </div>
    <div class="modalbody">
      <div class="generator">
        <div class="image"></div>
        <div class="fixed_info">
          <div class="hor_info">
            <div><img src="assets/icons/calendar.svg"><span></span></div>
            <div><img src="assets/icons/location.svg"><span></span></div>
          </div>
          <div class="img_info">
            <div><img src="assets/icons/temperature_circle.png"></div>
            <div><img src="assets/icons/temperature_circle.png"><span></span></div>
            <div><img src="assets/icons/battery_circle.png"><span></span></div>
            <div><img src="assets/icons/fuel_circle.png"><span></span></div>
          </div>
        </div>
      </div>
    <div class="data">
      </div>
    </div>
    <div class="modalfooter">
      <div class="status_icons"></div>
      <div></div>
      <div><button class="btn_img btn_graydark btn_report"></button></div>
      <button class="btn_img btn_graydark btn_point" title="{{ 'Show on the map'| translate }}"></button>
      <button class="btn_img btn_graydark btn_photo" title="{{'Show photos'|translate }}"></button>
      <button class="btn_img btn_graydark btn_code" title="{{ 'Send command to device'| translate }}"></button>
    </div>
  </div>

</div>
